/**
 * UpCart Pre-Order Notice
 *
 * UpCart replaces the native cart drawer with its own DOM, so the Liquid
 * snippet rendered into cart-drawer.liquid is ignored inside the drawer.
 * This script injects a styled pre-order notice into each UpCart product
 * item that corresponds to a cart line flagged as pre-order/OOS-with-continue
 * by sections/cart-preorder-data.liquid.
 */
(function () {
  "use strict";

  var NOTICE_CLASS = "upcart-preorder-notice";
  var DATA_SCRIPT_ID = "cart-preorder-data";
  var DEBUG = true; // set false to silence logs
  function log() {
    if (!DEBUG) return;
    try {
      var a = Array.prototype.slice.call(arguments);
      a.unshift("[upcart-preorder]");
      console.log.apply(console, a);
    } catch (e) {}
  }

  log("script loaded");

  var preorderMap = {}; // { variant_id: preorder_date | '' }

  function readPreorderData() {
    var el = document.getElementById(DATA_SCRIPT_ID);
    if (!el) {
      log("data script tag not found:", "#" + DATA_SCRIPT_ID);
      return;
    }
    try {
      var data = JSON.parse(el.textContent);
      var next = {};
      (data.items || []).forEach(function (item) {
        if (item && item.variant_id != null) {
          next[String(item.variant_id)] = item.preorder_date || "";
        }
      });
      preorderMap = next;
      log("preorder map loaded:", preorderMap);
    } catch (e) {
      log("failed to parse preorder data:", e);
    }
  }

  function buildNoticeEl(preorderDate) {
    var wrap = document.createElement("div");
    wrap.className = NOTICE_CLASS;
    wrap.setAttribute("role", "status");

    var iconHtml =
      '<span class="' +
      NOTICE_CLASS +
      '__icon" aria-hidden="true">' +
      '<svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12Z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
      '<path d="M8 4.667V8l2 2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
      "</svg></span>";

    var textHtml;
    if (preorderDate) {
      textHtml =
        '<span class="' +
        NOTICE_CLASS +
        '__text"><strong>PRE-ORDER</strong> &middot; ships starting <strong>' +
        escapeHtml(preorderDate) +
        "</strong></span>";
    } else {
      textHtml =
        '<span class="' +
        NOTICE_CLASS +
        '__text"><strong>PRE-ORDER</strong> &middot; will ship as soon as stock is available</span>';
    }

    wrap.innerHTML = iconHtml + textHtml;
    return wrap;
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function extractVariantId(itemEl) {
    // UpCart product item id format: "<variant_id>:<line_key>"
    var id = itemEl.getAttribute("id") || "";
    var match = id.match(/^(\d+):/);
    if (match) return match[1];

    // Fallback: look at variant in title link href
    var link = itemEl.querySelector(".upcart-product-title-link, a[href*='variant=']");
    if (link) {
      var href = link.getAttribute("href") || "";
      var qm = href.match(/[?&]variant=(\d+)/);
      if (qm) return qm[1];
    }
    return null;
  }

  function injectIntoItem(itemEl) {
    if (!itemEl || itemEl.querySelector("." + NOTICE_CLASS)) return;

    var variantId = extractVariantId(itemEl);
    if (!variantId) {
      log("could not extract variant_id from item", itemEl);
      return;
    }
    if (!(variantId in preorderMap)) {
      log("variant", variantId, "not in preorder map, skipping");
      return;
    }
    log("injecting notice for variant", variantId);

    var notice = buildNoticeEl(preorderMap[variantId]);
    var heading = itemEl.querySelector(".styles_ProductRow__productTitleAndVariant__, .upcart-product-title");
    if (heading) {
      // Place after the title block
      if (heading.classList.contains("upcart-product-title")) {
        // Insert right after the H3 title
        if (heading.parentNode) {
          heading.parentNode.insertBefore(notice, heading.nextSibling);
        }
      } else {
        heading.appendChild(notice);
      }
    } else {
      itemEl.appendChild(notice);
    }
  }

  function scanAndInject(root) {
    var scope = root || document;
    var items = scope.querySelectorAll(".upcart-product-item");
    if (items.length) log("scanning", items.length, "upcart product item(s)");
    for (var i = 0; i < items.length; i++) {
      injectIntoItem(items[i]);
    }
  }

  function refreshCartData() {
    return fetch("/?sections=cart-preorder-data", { credentials: "same-origin" })
      .then(function (res) {
        return res.json();
      })
      .then(function (json) {
        var html = json && json["cart-preorder-data"];
        if (!html) return;
        var tmp = document.createElement("div");
        tmp.innerHTML = html;
        var newScript = tmp.querySelector("#" + DATA_SCRIPT_ID);
        var existing = document.getElementById(DATA_SCRIPT_ID);
        if (newScript && existing && existing.parentNode) {
          existing.parentNode.replaceChild(newScript, existing);
        } else if (newScript) {
          document.body.appendChild(newScript);
        }
        readPreorderData();
        scanAndInject(document);
      })
      .catch(function () {
        // silent
      });
  }

  function hookCartFetch() {
    if (!window.fetch || window.__upcartPreorderHooked) return;
    window.__upcartPreorderHooked = true;
    var origFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var url = typeof input === "string" ? input : input && input.url;
      var isCartMutation = url && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
      var p = origFetch(input, init);
      if (isCartMutation) {
        p.then(function () {
          // Defer slightly so cart state settles, then refresh map
          setTimeout(refreshCartData, 50);
        }).catch(function () {});
      }
      return p;
    };

    // XHR (some apps still use it)
    if (window.XMLHttpRequest) {
      var origOpen = XMLHttpRequest.prototype.open;
      var origSend = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function (method, url) {
        this.__upcartUrl = url;
        return origOpen.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send = function () {
        var url = this.__upcartUrl || "";
        if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
          this.addEventListener("load", function () {
            setTimeout(refreshCartData, 50);
          });
        }
        return origSend.apply(this, arguments);
      };
    }
  }

  function init() {
    readPreorderData();
    scanAndInject(document);
    hookCartFetch();

    // Observe DOM changes (UpCart re-renders its drawer on open/update).
    // Debounce scans so we run at most every ~120ms even on chatty mutations.
    var scanTimer = null;
    function scheduleScan() {
      if (scanTimer) return;
      scanTimer = setTimeout(function () {
        scanTimer = null;
        scanAndInject(document);
      }, 120);
    }

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (!m.addedNodes || !m.addedNodes.length) continue;
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (n.nodeType !== 1) continue;
          var cls = n.className || "";
          if (
            (typeof cls === "string" && cls.indexOf("upcart") !== -1) ||
            (n.querySelector && n.querySelector(".upcart-product-item"))
          ) {
            scheduleScan();
            return;
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
